"use client";
import { useTranslations } from "next-intl";
import ProductItem from "./ProductItem";
import AddToCartButton from "../../../theme/components/AddToCartButton";
import ProductPrice from "./ProductPrice";
import Icon from "../../../common/components/Icon";
import StupidLoadMoreButton from "../../../theme/components/StupidLoadMoreButton";

export default function ProductList({
  products,
  filteredProductsCount,
  loading,
  onAddToCart,
  fetchMore,
  assortmentType,
  viewAs,
}: {
  products: Array<any>;
  filteredProductsCount: number;
  loading: boolean;
  onAddToCart: (product: any, quantity: number) => Promise<void>;
  fetchMore: any;
  assortmentType: string;
  viewAs?: "grid" | "list";
}) {
  const t = useTranslations();
  return (
    <>
      <div
        className={`product-list ${viewAs === "grid" ? "product-list--grid" : ""}  `}
      >
        {products?.map((product) => (
          <ProductItem
            key={product._id}
            shouldUseInstitutionalMigelConformity={
              assortmentType === "institution"
            }
            {...product}
            cutting={product?.publicareLastCuttingConfiguration?.cutting}
          >
            <div
              className="product-item__description"
              dangerouslySetInnerHTML={{ __html: product?.texts?.description }}
            />
            <ProductPrice price={product.simulatedPrice} />

            <div
              className="product-item__action d-lg-flex flex-lg-column justify-content-between"
              style={{ marginTop: "-8px" }}
            >
              {onAddToCart ? (
                <AddToCartButton
                  size="sm"
                  onAddToCart={(quantity) => onAddToCart(product, quantity)}
                />
              ) : null}
            </div>
          </ProductItem>
        ))}
      </div>
      {!loading && !products?.length && (
        <div className="text-center my-5">
          <Icon icon="sentiment-neutral" className="icon--xl" />
          <p className="d-block">{t("no_products_found")}</p>
        </div>
      )}
      <StupidLoadMoreButton
        className="my-3"
        loading={loading}
        maxLength={filteredProductsCount}
        arrayLength={products?.length ?? 0}
        fetchMore={fetchMore}
      />
    </>
  );
}
